export * from './icon-column-util';
export * from './tag-column-util';
export * from './primary-column-util';
export * from './action-column-util';
export * from './avatar-column-util';
export * from './plain-text-column-util';
/**
 * ObjectTableColumnKey is used for column field and colId's
 */
export var ObjectTableColumnKey;
(function (ObjectTableColumnKey) {
    ObjectTableColumnKey["Id"] = "id";
    ObjectTableColumnKey["Checkbox"] = "checkbox";
    ObjectTableColumnKey["MetadataType"] = "metadataType";
    ObjectTableColumnKey["Type"] = "type";
    ObjectTableColumnKey["Verified"] = "verified";
    ObjectTableColumnKey["PrimaryName"] = "primaryName";
    ObjectTableColumnKey["Favorite"] = "favorite";
    ObjectTableColumnKey["Tags"] = "tags";
    ObjectTableColumnKey["Author"] = "author";
    ObjectTableColumnKey["Views"] = "views";
    ObjectTableColumnKey["LastAccessed"] = "lastAccessed";
    ObjectTableColumnKey["LastModified"] = "lastModified";
    ObjectTableColumnKey["RowAction"] = "rowAction";
})(ObjectTableColumnKey || (ObjectTableColumnKey = {}));
export const convertToPlainText = (name) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(name, 'text/html');
    return doc.body.textContent;
};
export const getMeasureText = (text, fontSize) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = `${fontSize} sans-serif`;
    return context.measureText(text);
};
/**
 * ObjectTableColumnsMap is used for deciding if a column needs to be hidden in embed
 */
export var ObjectTableEmbedColumnsMap;
(function (ObjectTableEmbedColumnsMap) {
    ObjectTableEmbedColumnsMap["Favourite"] = "FAVOURITE";
    ObjectTableEmbedColumnsMap["Tags"] = "TAGS";
    ObjectTableEmbedColumnsMap["Author"] = "AUTHOR";
    ObjectTableEmbedColumnsMap["DateSort"] = "DATE_SORT";
    ObjectTableEmbedColumnsMap["Share"] = "SHARE";
    ObjectTableEmbedColumnsMap["Views"] = "VIEWS";
    ObjectTableEmbedColumnsMap["Verified"] = "VERIFIED";
    ObjectTableEmbedColumnsMap["MoreOptions"] = "MORE_OPTIONS";
})(ObjectTableEmbedColumnsMap || (ObjectTableEmbedColumnsMap = {}));
//# sourceMappingURL=object-table-column-util.js.map